// client/format.js — display helpers and user-facing copy that depends on data.
// All copy is lower case (UI.md §4).

/** 754000 -> "12:34" */
export function mmss(ms) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

/** Epoch ms -> local date and time, e.g. "8 oct 2026, 14:32" (CSS shows it lower case). */
export function dateTime(ms) {
  return new Date(ms).toLocaleString(undefined, {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export const MODE_LABEL = { audio: "audio", video: "video", either: "either" };

/** End-screen headings per reason and role. Mirrors SPEC.md §6. */
const END_COPY = {
  listener_ended: { listener: "you ended the session.", talker: "the listener ended the session." },
  listener_left: { listener: "you left, so the session ended.", talker: "the listener left. session ended." },
  listener_disconnected: {
    listener: "you were disconnected, so the session ended.",
    talker: "the listener lost connection. session ended.",
  },
  time_expired: { listener: "time's up.", talker: "time's up." },
};

/** Neutral wording for history (viewer may not have been in the session). */
const REASON_SHORT = {
  listener_ended: "listener ended",
  listener_left: "listener left",
  listener_disconnected: "listener disconnected",
  time_expired: "time's up",
};

export function endHeading(reason, role) {
  const copy = END_COPY[reason];
  if (!copy) return "session ended.";
  return copy[role] ?? REASON_SHORT[reason] + ".";
}

export function reasonShort(reason) {
  return REASON_SHORT[reason] ?? (reason ? reason : "in progress");
}

/** Talk time: from the talker connecting to the end (0 if they never connected). */
export function duration(row) {
  if (!row.talkerConnectedAt) return 0;
  return (row.endedAt ?? Date.now()) - row.talkerConnectedAt;
}
